const fileIconWordSvg = `<svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14426)">
<path d="M1 4C1 1.79086 2.79086 0 5 0H18.7245L30 11.1914V28C30 30.2091 28.2091 32 26 32H5C2.79086 32 1 30.2091 1 28V4Z" fill="url(#paint0_linear_25057_14426)"/>
<path d="M20.4315 23.5996C20.2061 23.5996 19.9844 23.513 19.8179 23.3494L15.514 19.1232L11.1806 23.3512C11.058 23.4709 10.9026 23.5519 10.7338 23.5841C10.565 23.6162 10.3903 23.5982 10.2319 23.5321C10.0733 23.4661 9.93795 23.3551 9.84275 23.213C9.74755 23.0708 9.69676 22.9039 9.69678 22.7332V12.466C9.69678 11.9877 10.0875 11.5996 10.5692 11.5996C11.0508 11.5996 11.4416 11.9877 11.4416 12.466V20.6676L14.9044 17.2886C15.2446 16.9568 15.7902 16.9576 16.129 17.2904L19.5587 20.6582V12.4898C19.5587 12.0115 19.9495 11.6234 20.4311 11.6234C20.9128 11.6234 21.3036 12.0115 21.3036 12.4898V22.7332C21.3036 23.0827 21.092 23.3982 20.7674 23.5328C20.6609 23.5768 20.5468 23.5995 20.4315 23.5996Z" fill="white"/>
<g filter="url(#filter0_f_25057_14426)">
<path d="M17.9165 0L29.9998 12H21.9165C19.7074 12 17.9165 10.2091 17.9165 8V0Z" fill="#196FF1"/>
</g>
<path d="M18.7222 0L29.9999 11.2H22.7222C20.513 11.2 18.7222 9.40914 18.7222 7.2V0Z" fill="#B3DAFF"/>
</g>
<defs>
<filter id="filter0_f_25057_14426" x="12.9165" y="-5" width="22.0835" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_25057_14426"/>
</filter>
<linearGradient id="paint0_linear_25057_14426" x1="1" y1="0" x2="32.9992" y2="32.2214" gradientUnits="userSpaceOnUse">
<stop stop-color="#76B4FD"/>
<stop offset="1" stop-color="#4C89FF"/>
</linearGradient>
<clipPath id="clip0_25057_14426">
<rect width="31" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconExcelSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14408)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14408)"/>
<path d="M17.3426 17.5996L21.7224 13.2197C22.0929 12.8492 22.0929 12.2481 21.7224 11.8775C21.3518 11.507 20.7507 11.507 20.3802 11.8775L16.0003 16.2573L11.6205 11.8775C11.25 11.507 10.6489 11.507 10.2783 11.8775C9.90776 12.2481 9.90776 12.8492 10.2783 13.2197L14.6581 17.5996L10.2779 21.9794C9.90736 22.3499 9.90736 22.951 10.2779 23.3216C10.4634 23.5071 10.7062 23.5996 10.949 23.5996C11.1918 23.5996 11.4347 23.5071 11.6201 23.3216L16.0003 18.9418L20.3798 23.3216C20.5652 23.5071 20.8081 23.5996 21.0509 23.5996C21.2937 23.5996 21.5365 23.5071 21.722 23.3216C22.0925 22.951 22.0925 22.3499 21.722 21.9794L17.3426 17.5996Z" fill="white"/>
<g filter="url(#filter0_f_25057_14408)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#15C46F"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#A4F8D0"/>
</g>
<defs>
<filter id="filter0_f_25057_14408" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14408"/>
</filter>
<linearGradient id="paint0_linear_25057_14408" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#6CE4A3"/>
<stop offset="1" stop-color="#15D076"/>
</linearGradient>
<clipPath id="clip0_25057_14408">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconTxtSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14410)">
<path d="M1.5 4C1.5 1.79086 3.29086 0 5.5 0H19.2245L30.5 11.1914V28C30.5 30.2091 28.7091 32 26.5 32H5.5C3.29086 32 1.5 30.2091 1.5 28V4Z" fill="url(#paint0_linear_25057_14410)"/>
<path d="M21.2412 12.1295H16.1613C16.055 12.1079 15.9453 12.1079 15.839 12.1295H10.7591C10.3171 12.1295 9.9585 12.4857 9.9585 12.9246C9.9585 13.3636 10.3171 13.7197 10.7591 13.7197H15.1995V22.2912C15.1995 22.7301 15.5582 23.0863 16.0002 23.0863C16.4422 23.0863 16.8008 22.7301 16.8008 22.2912V13.7197H21.2412C21.6832 13.7197 22.0418 13.3636 22.0418 12.9246C22.0418 12.4857 21.6832 12.1295 21.2412 12.1295Z" fill="white"/>
<g filter="url(#filter0_f_25057_14410)">
<path d="M18.4165 0L30.4998 12H22.4165C20.2074 12 18.4165 10.2091 18.4165 8V0Z" fill="#35B4F0"/>
</g>
<path d="M19.2222 0L30.4999 11.2H23.2222C21.013 11.2 19.2222 9.40914 19.2222 7.2V0Z" fill="#ACEFFA"/>
</g>
<defs>
<filter id="filter0_f_25057_14410" x="13.4165" y="-5" width="22.0835" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2.5" result="effect1_foregroundBlur_25057_14410"/>
</filter>
<linearGradient id="paint0_linear_25057_14410" x1="1.5" y1="0" x2="33.4992" y2="32.2214" gradientUnits="userSpaceOnUse">
<stop stop-color="#77DFFE"/>
<stop offset="1" stop-color="#4AC5FD"/>
</linearGradient>
<clipPath id="clip0_25057_14410">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconPdfSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14412)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14412)"/>
<g clip-path="url(#clip1_25057_14412)">
<path d="M20.6223 21.564C19.6623 21.4929 18.7379 21.1373 17.9912 20.4973C16.5334 20.8173 15.1468 21.2795 13.7601 21.8484C12.6579 23.804 11.6268 24.7995 10.7379 24.7995C10.5601 24.7995 10.3468 24.764 10.2045 24.6573C9.81343 24.4795 9.6001 24.0884 9.6001 23.6973C9.6001 23.3773 9.67121 22.4884 13.049 21.0306C13.8312 19.6084 14.4357 18.1506 14.9334 16.6218C14.5068 15.7684 13.5823 13.6706 14.2223 12.604C14.4357 12.2129 14.8623 11.9995 15.3245 12.0351C15.6801 12.0351 16.0357 12.2129 16.249 12.4973C16.7112 13.1373 16.6757 14.4884 16.0712 16.4795C16.6401 17.5462 17.3868 18.5062 18.2757 19.324C19.0223 19.1818 19.769 19.0751 20.5157 19.0751C22.1868 19.1106 22.4357 19.8929 22.4001 20.3551C22.4001 21.564 21.2268 21.564 20.6223 21.564ZM10.6668 23.7684L10.7734 23.7329C11.2712 23.5551 11.6623 23.1995 11.9468 22.7373C11.4134 22.9506 10.9868 23.3062 10.6668 23.7684ZM15.3957 13.1018H15.289C15.2534 13.1018 15.1823 13.1018 15.1468 13.1373C15.0045 13.7418 15.1112 14.3818 15.3601 14.9506C15.5734 14.3462 15.5734 13.7062 15.3957 13.1018ZM15.6445 18.2573L15.609 18.3284L15.5734 18.2929C15.2534 19.1106 14.8979 19.9284 14.5068 20.7106L14.5779 20.6751V20.7462C15.3601 20.4618 16.2134 20.2129 16.9957 20.0351L16.9601 19.9995H17.0668C16.5334 19.4662 16.0357 18.8618 15.6445 18.2573ZM20.4801 20.1418C20.1601 20.1418 19.8757 20.1418 19.5557 20.2129C19.9112 20.3906 20.2668 20.4618 20.6223 20.4973C20.8712 20.5329 21.1201 20.4973 21.3334 20.4262C21.3334 20.3195 21.1912 20.1418 20.4801 20.1418Z" fill="white"/>
</g>
<g filter="url(#filter0_f_25057_14412)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#F61E22"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#FCAFB0"/>
</g>
<defs>
<filter id="filter0_f_25057_14412" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14412"/>
</filter>
<linearGradient id="paint0_linear_25057_14412" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF7375"/>
<stop offset="1" stop-color="#FF4447"/>
</linearGradient>
<clipPath id="clip0_25057_14412">
<rect width="32" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_25057_14412">
<rect width="12.8" height="12.8" fill="white" transform="translate(9.6001 12)"/>
</clipPath>
</defs>
</svg>`;

const fileIconMarkdownSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14428)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14428)"/>
<path d="M11.103 11.5996C11.3268 11.5996 11.547 11.6863 11.7123 11.8498L15.9866 16.076L20.2901 11.848C20.4118 11.7283 20.5662 11.6473 20.7338 11.6152C20.9015 11.583 21.0749 11.6011 21.2323 11.6671C21.3897 11.7331 21.5242 11.8441 21.6187 11.9863C21.7133 12.1284 21.7637 12.2953 21.7637 12.466L21.7637 22.7332C21.7637 23.2115 21.3756 23.5996 20.8973 23.5996C20.4189 23.5996 20.0309 23.2115 20.0309 22.7332L20.0309 14.5317L16.592 17.9106C16.2541 18.2424 15.7122 18.2416 15.3758 17.9088L11.9697 14.541L11.9697 22.7094C11.9697 23.1877 11.5817 23.5758 11.1033 23.5758C10.625 23.5758 10.2369 23.1877 10.2369 22.7094L10.2369 12.466C10.2369 12.1166 10.447 11.8011 10.7694 11.6664C10.8751 11.6224 10.9885 11.5997 11.103 11.5996Z" fill="white"/>
<g filter="url(#filter0_f_25057_14428)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#7319F1"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#C2B3FF"/>
</g>
<defs>
<filter id="filter0_f_25057_14428" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14428"/>
</filter>
<linearGradient id="paint0_linear_25057_14428" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#A176FD"/>
<stop offset="1" stop-color="#974CFF"/>
</linearGradient>
<clipPath id="clip0_25057_14428">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconCodeSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14430)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14430)"/>
<path d="M12.99 12.5654C12.8248 12.4187 12.5721 12.4336 12.4253 12.5987L8.73621 16.7491C8.6015 16.9006 8.6015 17.129 8.73621 17.2805L12.4253 21.4309C12.5721 21.596 12.8248 21.6109 12.99 21.4642L13.5134 20.9991C13.6786 20.8523 13.6935 20.5994 13.5467 20.4343L10.7432 17.2806C10.6085 17.129 10.6085 16.9006 10.7432 16.7491L13.5467 13.5953C13.6935 13.4302 13.6786 13.1773 13.5134 13.0306L12.99 12.5654ZM19.3868 12.5988C19.24 12.4336 18.9872 12.4188 18.8221 12.5656L18.299 13.0306C18.1338 13.1773 18.119 13.4302 18.2658 13.5953L21.0693 16.7491C21.204 16.9006 21.204 17.129 21.0693 17.2806L18.2658 20.4343C18.119 20.5995 18.1338 20.8523 18.299 20.9991L18.8221 21.4641C18.9872 21.6108 19.24 21.596 19.3868 21.4309L23.0762 17.2806C23.211 17.129 23.211 16.9006 23.0762 16.749L19.3868 12.5988Z" fill="white"/>
<g filter="url(#filter0_f_25057_14430)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#3396FD"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#9FD3FB"/>
</g>
<defs>
<filter id="filter0_f_25057_14430" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14430"/>
</filter>
<linearGradient id="paint0_linear_25057_14430" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#44B6FB"/>
<stop offset="1" stop-color="#58A2FF"/>
</linearGradient>
<clipPath id="clip0_25057_14430">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconPptSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14414)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14414)"/>
<path d="M17.3009 11.5996H11.2913C10.838 11.5996 10.4702 11.9674 10.4702 12.4207V22.7785C10.4702 23.2318 10.838 23.5996 11.2913 23.5996C11.7447 23.5996 12.1125 23.2318 12.1125 22.7785V20.0578H17.3009C19.6329 20.0578 21.53 18.1607 21.53 15.8287C21.53 13.4967 19.6329 11.5996 17.3009 11.5996ZM17.3009 18.4156H12.1125V13.2419H17.3009C18.7273 13.2419 19.8878 14.4024 19.8878 15.8287C19.8878 17.2551 18.7273 18.4156 17.3009 18.4156Z" fill="white"/>
<g filter="url(#filter0_f_25057_14414)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#F6791E"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#FCCBAF"/>
</g>
<defs>
<filter id="filter0_f_25057_14414" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14414"/>
</filter>
<linearGradient id="paint0_linear_25057_14414" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFA573"/>
<stop offset="1" stop-color="#FF7C44"/>
</linearGradient>
<clipPath id="clip0_25057_14414">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconImageSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14416)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14416)"/>
<path d="M8.24289 22.3479L11.1107 18.1328C11.1475 18.0788 11.1956 18.0335 11.2518 18.0001C11.3079 17.9668 11.3707 17.9461 11.4357 17.9397C11.5007 17.9333 11.5664 17.9413 11.628 17.9631C11.6895 17.9848 11.7456 18.0199 11.7921 18.0657L13.6875 19.9227L17.8459 13.4047C17.8871 13.34 17.9442 13.287 18.0119 13.2509C18.0795 13.2147 18.1553 13.1966 18.232 13.1984C18.3086 13.2001 18.3835 13.2215 18.4495 13.2607C18.5154 13.2998 18.5701 13.3553 18.6084 13.4218L23.7752 22.376C23.8144 22.4438 23.8351 22.5208 23.8351 22.5991C23.8352 22.6774 23.8146 22.7544 23.7754 22.8222C23.7362 22.8901 23.6799 22.9464 23.612 22.9855C23.5441 23.0246 23.4672 23.0452 23.3888 23.0451H8.61173C8.53054 23.0452 8.45085 23.0232 8.38126 22.9814C8.31167 22.9396 8.25481 22.8796 8.21683 22.8079C8.17885 22.7361 8.16118 22.6553 8.16574 22.5743C8.1703 22.4932 8.19691 22.415 8.2427 22.3479H8.24289Z" fill="white"/>
<path d="M9.10156 12.8039C9.10156 13.4001 9.33843 13.972 9.76005 14.3936C10.1817 14.8152 10.7535 15.0521 11.3498 15.0521C11.946 15.0521 12.5179 14.8152 12.9395 14.3936C13.3611 13.972 13.598 13.4001 13.598 12.8039C13.598 12.2076 13.3611 11.6358 12.9395 11.2141C12.5179 10.7925 11.946 10.5557 11.3498 10.5557C10.7535 10.5557 10.1817 10.7925 9.76005 11.2141C9.33843 11.6358 9.10156 12.2076 9.10156 12.8039Z" fill="white"/>
<g filter="url(#filter0_f_25057_14416)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#EFB323"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#FEE7B5"/>
</g>
<defs>
<filter id="filter0_f_25057_14416" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14416"/>
</filter>
<linearGradient id="paint0_linear_25057_14416" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#FED067"/>
<stop offset="1" stop-color="#FEB646"/>
</linearGradient>
<clipPath id="clip0_25057_14416">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconAudioSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14418)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14418)"/>
<path d="M21.0555 13.7107C20.2303 13.7107 19.439 13.3829 18.8556 12.7995C18.2721 12.2161 17.9443 11.4247 17.9443 10.5996H16.3888V18.1907C15.74 17.7572 14.9649 17.5529 14.1867 17.6104C13.4084 17.6679 12.6717 17.9837 12.0936 18.5078C11.5155 19.0319 11.1291 19.7342 10.9958 20.503C10.8625 21.2719 10.99 22.0633 11.3579 22.7514C11.7259 23.4395 12.3133 23.9849 13.0268 24.301C13.7402 24.617 14.5388 24.6856 15.2957 24.4958C16.0526 24.306 16.7244 23.8686 17.2043 23.2533C17.6841 22.638 17.9446 21.8799 17.9443 21.0996V14.0724C18.7991 14.8397 19.9068 15.2648 21.0555 15.2663V13.7107Z" fill="white"/>
<g filter="url(#filter0_f_25057_14418)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#FA655E"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#FEC6C2"/>
</g>
<defs>
<filter id="filter0_f_25057_14418" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14418"/>
</filter>
<linearGradient id="paint0_linear_25057_14418" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDA79C"/>
<stop offset="1" stop-color="#FF8787"/>
</linearGradient>
<clipPath id="clip0_25057_14418">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconVideoSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14420)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14420)"/>
<path d="M13.4813 12.9902C13.215 12.821 12.8667 13.0123 12.8667 13.3278V21.8714C12.8667 22.187 13.215 22.3783 13.4813 22.209L20.2022 17.9372C20.4495 17.78 20.4495 17.4192 20.2022 17.262L13.4813 12.9902Z" fill="white"/>
<g filter="url(#filter0_f_25057_14420)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#F6791E"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#FCCFAF"/>
</g>
<defs>
<filter id="filter0_f_25057_14420" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14420"/>
</filter>
<linearGradient id="paint0_linear_25057_14420" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFBF83"/>
<stop offset="1" stop-color="#FF9C54"/>
</linearGradient>
<clipPath id="clip0_25057_14420">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconZipSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14422)">
<g filter="url(#filter0_i_25057_14422)">
<path d="M0 3.99297C0 2.22566 1.43269 0.792969 3.2 0.792969H28.8C30.5673 0.792969 32 2.22566 32 3.99297V10.9263H0V3.99297Z" fill="url(#paint0_linear_25057_14422)"/>
</g>
<rect y="10.9268" width="32" height="10.1333" fill="url(#paint1_linear_25057_14422)"/>
<path d="M0 21.0596H32V27.9929C32 29.7602 30.5673 31.1929 28.8 31.1929H3.2C1.43269 31.1929 0 29.7602 0 27.9929V21.0596Z" fill="url(#paint2_linear_25057_14422)"/>
<rect x="10.3999" y="0.807617" width="11.2" height="30.4" fill="url(#paint3_linear_25057_14422)"/>
<rect x="9.5999" y="11.2" width="12.8" height="9.6" rx="2.4" stroke="white" stroke-width="1.6"/>
</g>
<defs>
<filter id="filter0_i_25057_14422" x="0" y="0.792969" width="32" height="11.7338" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.6"/>
<feGaussianBlur stdDeviation="0.8"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.609328 0 0 0 0 0.882798 0 0 0 0 1 0 0 0 0.6 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_25057_14422"/>
</filter>
<linearGradient id="paint0_linear_25057_14422" x1="0" y1="0.792969" x2="7.48984" y2="19.5629" gradientUnits="userSpaceOnUse">
<stop stop-color="#66D3F9"/>
<stop offset="1" stop-color="#4BC1FB"/>
</linearGradient>
<linearGradient id="paint1_linear_25057_14422" x1="0" y1="10.9268" x2="7.48984" y2="29.6967" gradientUnits="userSpaceOnUse">
<stop stop-color="#FD836F"/>
<stop offset="1" stop-color="#FF5F5D"/>
</linearGradient>
<linearGradient id="paint2_linear_25057_14422" x1="0" y1="21.0596" x2="7.48984" y2="39.8295" gradientUnits="userSpaceOnUse">
<stop stop-color="#7BE0B1"/>
<stop offset="1" stop-color="#51B783"/>
</linearGradient>
<linearGradient id="paint3_linear_25057_14422" x1="10.3999" y1="0.807617" x2="27.9819" y2="5.94811" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD26D"/>
<stop offset="1" stop-color="#FFB340"/>
</linearGradient>
<clipPath id="clip0_25057_14422">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

const fileIconDefaultSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_25057_14424)">
<path d="M1.6001 3.2C1.6001 1.43269 3.03279 0 4.8001 0H19.2024L30.4001 11.1914V28.8C30.4001 30.5673 28.9674 32 27.2001 32H4.8001C3.03279 32 1.6001 30.5673 1.6001 28.8V3.2Z" fill="url(#paint0_linear_25057_14424)"/>
<rect x="9.87842" y="11.3555" width="8" height="1.6" rx="0.4" fill="white"/>
<rect x="9.87842" y="16.8574" width="12.2432" height="1.6" rx="0.4" fill="white"/>
<rect x="9.87842" y="22.3594" width="11.3717" height="1.48611" rx="0.4" fill="white"/>
<g filter="url(#filter0_f_25057_14424)">
<path d="M18.3999 0L30.3999 12H21.5999C19.8326 12 18.3999 10.5673 18.3999 8.8V0Z" fill="#94B9DB"/>
</g>
<path d="M19.2002 0L30.4002 11.2H22.4002C20.6329 11.2 19.2002 9.76731 19.2002 8V0Z" fill="#DBEAFC"/>
</g>
<defs>
<filter id="filter0_f_25057_14424" x="14.3999" y="-4" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_25057_14424"/>
</filter>
<linearGradient id="paint0_linear_25057_14424" x1="1.6001" y1="0" x2="33.6001" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-color="#C7DFF2"/>
<stop offset="1" stop-color="#ABC3DD"/>
</linearGradient>
<clipPath id="clip0_25057_14424">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;

function toDataUrl(svg: string) {
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

const BUILTIN_FILE_ICON_URLS = {
    word: toDataUrl(fileIconWordSvg),
    excel: toDataUrl(fileIconExcelSvg),
    txt: toDataUrl(fileIconTxtSvg),
    pdf: toDataUrl(fileIconPdfSvg),
    markdown: toDataUrl(fileIconMarkdownSvg),
    code: toDataUrl(fileIconCodeSvg),
    ppt: toDataUrl(fileIconPptSvg),
    zip: toDataUrl(fileIconZipSvg),
    image: toDataUrl(fileIconImageSvg),
    audio: toDataUrl(fileIconAudioSvg),
    video: toDataUrl(fileIconVideoSvg),
    default: toDataUrl(fileIconDefaultSvg),
};

const WORD_EXTENSIONS = new Set([
    'doc',
    'docx',
    'pages',
]);

const EXCEL_EXTENSIONS = new Set([
    'xls',
    'xlsx',
    'csv',
    'numbers',
]);

const TXT_EXTENSIONS = new Set([
    'txt',
    'log',
    'rtf',
]);

const MARKDOWN_EXTENSIONS = new Set([
    'md',
    'mdx',
    'markdown',
]);

const CODE_EXTENSIONS = new Set([
    'js',
    'mjs',
    'cjs',
    'jsx',
    'ts',
    'tsx',
    'vue',
    'html',
    'htm',
    'css',
    'scss',
    'sass',
    'less',
    'json',
    'yaml',
    'yml',
    'xml',
    'java',
    'kt',
    'go',
    'rs',
    'py',
    'rb',
    'php',
    'c',
    'cc',
    'cpp',
    'h',
    'hpp',
    'swift',
    'sh',
    'bash',
    'zsh',
    'sql',
]);

const PPT_EXTENSIONS = new Set([
    'ppt',
    'pptx',
    'key',
]);

const ZIP_EXTENSIONS = new Set([
    'zip',
    'rar',
    '7z',
    'tar',
    'gz',
    'tgz',
    'bz2',
    'xz',
]);

export function getBuiltinFileIconByExtension(
    ext: string,
    resolvedType: 'file' | 'image' | 'video' | 'audio' = 'file'
) {
    if (WORD_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.word;
    if (EXCEL_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.excel;
    if (TXT_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.txt;
    if (ext === 'pdf') return BUILTIN_FILE_ICON_URLS.pdf;
    if (MARKDOWN_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.markdown;
    if (CODE_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.code;
    if (PPT_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.ppt;
    if (ZIP_EXTENSIONS.has(ext)) return BUILTIN_FILE_ICON_URLS.zip;
    if (resolvedType === 'image') return BUILTIN_FILE_ICON_URLS.image;
    if (resolvedType === 'audio') return BUILTIN_FILE_ICON_URLS.audio;
    if (resolvedType === 'video') return BUILTIN_FILE_ICON_URLS.video;

    return BUILTIN_FILE_ICON_URLS.default;
}
